import React, { useContext, useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router";
import { useParams } from "react-router-dom";
import API from "../Utility";
import {
  Row,
  Col,
  Button,
  Modal,
  Form,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import Table, { DefaultTableSettings } from "../Utility/Table";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import styled from "styled-components";
import { textColor } from "../Theme/Theme";
import { FaPlus, FaLock } from "react-icons/fa";
import { BsLink45Deg } from "react-icons/bs";
// import CreateUserFormModal from "./CreateUserFormModal";
import UploadUsersFormModal from "./UploadUsersFormModal";
import Search from "../Search";
import Moment from "react-moment";

import variables from "../../variables.scss";

// Styles
import "./UsersView.scss";

export default function UsersView({ children, location, ...routeProps }) {
  const { project } = useParams();
  const usersUrl = `/admin/${project}/users`;
  const [tableData, setTableData] = useState([]);
  const [columnData, setColumnData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState();
  const [totalSize, setTotalSize] = useState(0);
  const [filter, setFilter] = useState({ ...DefaultTableSettings });
  const [isLoading, setIsLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  // const [showCreateNewModal, setShowCreateNewModal] = useState();
  const [showUploadUsersFormModal, setShowUploadUsersFormModal] = useState();
  const [newUserData, setNewUserData] = useState([]);

  let columns = [
    {
      dataField: "providerData.displayName",
      text: "Name",
      headerStyle: { textAlign: "left", width: "30%" },
      style: { textAlign: "left", width: "30%" },
      formatter: function callback(cell, row) {
        return (
          <span>
            {" "}
            {cell}
            {!row.isUserControlled ? (
              <BsLink45Deg
                style={{
                  marginLeft: "5px",
                  fontSize: "15px",
                  strokeWidth: "0.3px",
                }}
              ></BsLink45Deg>
            ) : null}
          </span>
        );
      },
    },
    {
      dataField: "username",
      text: "Username",
      headerStyle: { textAlign: "left", width: "40%" },
      style: { textAlign: "left", width: "40%" }
    },
  ];

  async function getUserData({
    query = null,
    url = usersUrl,
    params = filter,
  }) {
    setTableData([]);
    setNewUserData([]);
    setIsLoading(true);
    params.nameMatch = query;
    setFilter(params);
    const { filteredResults, totalResultsCount } = await API.get({
      url: url,
      params: params,
    });
    const { fields } = await API.get({
      url: `/admin/${project}/providerDataConfig?isAdmin=true`,
    });
    setTableData(filteredResults);
    setNewUserData({ providerDataConfig: fields });
    setTotalSize(totalResultsCount);
    setIsLoading(false);
    compileColumnData(filteredResults[0]);
  }

  useEffect(() => {
    async function initializeData() {
      await getUserData({
        params: {
          page: DefaultTableSettings.page,
          pageSize: DefaultTableSettings.sizePerPage,
        },
      });
    }

    initializeData();
  }, []);

  const tooltipPlacement = "top";
  const tooltipTitle = "Warning";
  const tooltipMessage =
    "This record is linked to an external data source that may overwrite your changes";

  const compileColumnData = (user) => {
    // if (user && user.additionalFields) {
    //   for (let prop in user.additionalFields) {
    //     if (prop === "brand") {
    //       if (
    //         Object.prototype.hasOwnProperty.call(user.additionalFields, prop)
    //       ) {
    //         columns.push({
    //           dataField: "providerData." + prop,
    //           text: user.additionalFields[prop],
    //         });
    //       }
    //     }
    //   }
    // }
    columns.push({
      dataField: "created",
      text: "Created Date",
      headerStyle: { textAlign: "left", width: "20%" },
      style: { textAlign: "left", width: "20%" },
      formatter: function callback(cell, row) {
        if(cell){
          return <Moment format="DD MMM 'YY">{cell}</Moment>;
        }else{
          return null;
        }

      },
    });
    setColumnData(columns);
  };

  const loading = () => {
    return tableData.length < 1 && isLoading ? (
      <div>
        <Spinner animation="border" />
      </div>
    ) : (
      <div>
        <span>No results</span>
      </div>
    );
  };

  const onTableChange = async (type, { sortField, sortOrder, data, page }) => {
    setCurrentPage(page);
    await getUserData({
      query: searchText,
      params: {
        page: page,
        pageSize: DefaultTableSettings.sizePerPage,
        sortType: sortField,
        sortDir: 1,
        nameMatch: null,
      },
    });
  };

  let history = useHistory();

  const rowClasses = "clickable react-bootstrap-table__row";

  const selectRow = {
    mode: "radio",
    style: {
      background: variables.pubhubPrimary,
      color: variables.pubhubPrimaryAlt,
    },
    clickToSelect: true,
    hideSelectColumn: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      history.push(`/users/${project}/${row._id}`);
    },
  };

  const createUserFormModalOnSuccess = ({ _id }) => {
    // setShowCreateNewModal(false);
    history.push(`/users/${project}/${_id}`);
  };

  const onSelected = (e) => {
    setSelected(e);
  };

  const onSuccessUploadUsersFormModal = () => {
    setShowUploadUsersFormModal(false);
    async function reload() {
      let queryData = {
        params: {
          page: currentPage,
          pageSize: DefaultTableSettings.sizePerPage,
        }
      };
      searchText?.[0] ? queryData.query = searchText : null;
      await getUserData(queryData);
    }
    reload();
  };

  return (
    <div className="users-list-view">
      <Row>
        <Col lg={6}>
          <h2>Users</h2>
        </Col>
        <Col lg={6}>
          <div
            className="users-list-view__search-form flex flex-row"
            style={{ marginLeft: "5px" }}
          >
            <Search
              placeholder="Search"
              labelKey="username"
              options={tableData}
              isLoading={isLoading}
              isTypeAhead={false}
              minLength={3}
              delay={450}
              callback={(text) => {
                setCurrentPage(1);
                let currentParams = filter;
                currentParams.page = 1;
                setSearchText(text);
                return getUserData({ query: text, params: currentParams });
              }}
            />
            <Button
              onClick={() => {
                history.push({
                  pathname: `/users/${project}/create`,
                  state: { user: newUserData },
                });
              }}
              variant="outline-primary"
            >
              <span style={{ verticalAlign: "middle", fontSize: '30px', lineHeight: '10px', marginTop: '-6px' }}>+</span>
              <span style={{ verticalAlign: "middle" }}> New User</span>
            </Button>
            <Button
              onClick={() => {
                setShowUploadUsersFormModal(true);
              }}
              variant="outline-primary"
            >
              <span style={{ verticalAlign: "middle", fontSize: '30px', lineHeight: '10px', marginTop: '-6px' }}>+</span>
              <span style={{ verticalAlign: "middle" }}> Upload Users</span>
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          {columnData && columnData.length > 0 ? (
            <Table
              remote
              columns={columnData}
              keyField={"username"}
              data={tableData}
              onTableChange={onTableChange}
              noDataIndication={loading}
              page={currentPage}
              totalSize={totalSize}
              selectRow={selectRow}
              rowClasses={rowClasses}
            />
          ) : (
            <div className="w-100 text-center p-5">
              <Spinner animation="border" />
            </div>
          )}
        </Col>
      </Row>

      {/* <CreateUserFormModal
        show={showCreateNewModal}
        onCancel={() => {
          setShowCreateNewModal(false);
        }}
        onSuccess={createUserFormModalOnSuccess}
      /> */}
      <UploadUsersFormModal
        show={showUploadUsersFormModal}
        onCancel={() => {
          setShowUploadUsersFormModal(false);
        }}
        onSuccess={onSuccessUploadUsersFormModal}
      />
      {/*<LibrarySelector
        title="Choose Library"
        show={showLibrarySelectorModal}
        confirmtext={"Save"}
        onHide={(event, exitValue) => {
          setShowLibrarySelectorModal(false);
        }}/>*/}
    </div>
  );
}
